// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__BBdIq","title":"ClientReferral_title__3hsNy","itemText":"ClientReferral_itemText__2Mn-l"};